export default {
  data() {
    return {
      rowSelection: [],
      rowData: [],
      selectable: true,
    };
  },
  methods: {
    // Prevents text selection when using shift to select rows.
    handleShiftKey() {
      document.onselectstart = () => false;
    },

    // Prevents the context menu opening on right-click and ctrl + click.
    handleContextMenu() {
      document.oncontextmenu = () => false;
    },

    // Saves the response to an array (need row numbers for row shift-select).
    // onSuccess(response) {
    //   this.rowData = response.data.data.map(row => row.id);
    // },

    // Applies a css class to selected rows.
    applyRowClass(dataItem) {
      return this.rowSelection.indexOf(dataItem.id) > -1 ? 'ctrl-row-select' : '';
    },

    removeRows(key) {
      if (this.rowSelection.length) {
        // Build querystring for the removal
        let selection = [];
        this.rowSelection.forEach((id) => {
          selection.push(`${key}[]=${id}`);
        });
        selection = selection.join('&');

        // Dialog
        this.$q.dialog({
          title: ' ',
          message: (this.rowSelection.length > 1)
            ? this.$store.state.stringsStore.strings.module.library.delete.title.multiple
            : this.$store.state.stringsStore.strings.module.library.delete.title.single,
          ok: this.$store.state.stringsStore.strings.dialog.confirm.ok,
          cancel: this.$store.state.stringsStore.strings.dialog.confirm.cancel,
        }).then(() => {
          // delete call
          this.axios.delete(`${this.endpoint}`, { data: selection })
            .then(() => {
              this.rowSelection = [];
              // Refresh data to see the result
              this.$refs.vuetable && this.$refs.vuetable.refresh();

              // Fetch new me and navigation since the users own rights may have been affected.
              this.$store.dispatch('getMe');
              this.$store.dispatch('getNavigation');

              this.$q.notify({
                message: (this.rowSelection.length > 1)
                  ? this.$store.state.stringsStore.strings.module.library.delete.deleted.multiple
                  : this.$store.state.stringsStore.strings.module.library.delete.deleted.single,
                position: 'top-right',
                timeout: 1000,
                color: 'positive',
              });
            })
            .catch((error) => {
              // Error
              console.warn('error', error);
            });
        }).catch(() => {
          console.info('Nothing removed');
        });
      }
    },

    shiftSelect(row) {
      // rowIndexes is used to store the positions (row numbers) of the rows.
      // This is sorted so that intermediate rows can be added to rowSelection regardless of id.
      const rowIndexes = [];

      // The row numbers of the first & last rows in the selection.
      const firstRow = this.rowData.indexOf(this.rowSelection[0]);
      const lastRow = this.rowData.indexOf(this.rowSelection[this.rowSelection.length - 1]);

      // Push the position of the selected row into rowIndexes.
      rowIndexes.push(this.rowData.indexOf(row.id));

      // Check if clicked row is above the first rowSelection item.
      if (rowIndexes[0] > firstRow) {
        // If true, push the first rowSelection item.
        rowIndexes.push(firstRow);

        // If false push the last rowSelection item.
      } else {
        rowIndexes.push(lastRow);
      }

      // Sort the rowIndex array from smallest to largest.
      rowIndexes.sort((a, b) => a - b);

      // Empty row selection
      this.rowSelection = [];

      // Select all rows
      for (let i = rowIndexes[0]; i <= rowIndexes[rowIndexes.length - 1]; i += 1) {
        this.rowSelection.push(this.rowData[i]);
      }
    },

    // Selects rows on row click.
    selectRows(row, event) {
      // If metaKey is pressed & the row is not in the selection, add to selection
      if (!this.rowSelection.includes(row.id) && event.metaKey) {
        this.rowSelection.push(row.id);

      // If metaKey is pressed & the row is already in the selection, remove from selection.
      } else if (this.rowSelection.includes(row.id) && event.metaKey) {
        this.rowSelection.splice(this.rowSelection.indexOf(row.id), 1);

      // If the current row is the only row selected, go to the row detail when clicked again.
      } else if (this.rowSelection.length === 1 && this.rowSelection.includes(row.id)) {
        if (this.$store.state.meStore.me.rights.includes(`${this.permission}.edit`) || this.$store.state.meStore.me.su) {
          this.$router.push(`/${this.module}/${row.id}`);
        }

      // When using shift select, we need to select on row number due to sorted columns.
      } else if (event.shiftKey && this.rowSelection.length) {
        this.shiftSelect(row);

      // Simple click sets the clicked row as the rowSelection.
      } else {
        this.rowSelection = [row.id];
      }
    },
  },
  mounted() {
    // Prevent default events for shift key & context menu
    document.addEventListener('selectstart', this.handleShiftKey, { passive: true });
    document.addEventListener('contextmenu', this.handleContextMenu, { passive: true });
  },
  destroyed() {
    // Clean up
    document.removeEventListener('selectstart', this.handleShiftKey);
    document.removeEventListener('contextmenu', this.handleContextMenu);
  },
};
